import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterDropdownComponent } from './components';
import { UiModule } from '@shabic/ui';
import { TranslateModule } from '@ngx-translate/core';
import { FormControlModule } from '@shabic/form-control';
import { IconModule } from '@shabic/icon';
import { SizeDropdownComponent } from './components/size-dropdown/size-dropdown.component';

@NgModule({
  declarations: [FilterDropdownComponent, SizeDropdownComponent],
  imports: [
    CommonModule,
    UiModule,
    TranslateModule,
    FormControlModule,
    IconModule,
  ],
  exports: [FilterDropdownComponent,SizeDropdownComponent],
})
export class FiltersModule {}
